import { useNotificationRead } from '@/fsd/entities/notifications/model/hooks/useNotificationRead';
import {
  Notification,
  NotificationStatus,
  Operation,
} from '@/fsd/entities/notifications/model/types/types';
import { Collapse } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import styles from '../NotificationItem/NotificationItem.module.scss';

interface IProps {
  item: Notification;
  expanded: boolean;
  setExpanded: Dispatch<SetStateAction<boolean>>;
  status: NotificationStatus;
}

const NotificationItemsContent = ({
  item,
  expanded,
  setExpanded,
  status,
}: IProps) => {
  const { readNotification } = useNotificationRead({ status });
  const handleToggleExpand = () => {
    setExpanded((prev) => {
      if (!prev && item.status === 'new') {
        readNotification({
          action: 'mark_read',
          target: 'single',
          notification_id: item.notification_id,
        });
      }
      return !prev;
    });
  };

  return (
    <>
      <h5 className={styles.title}>{String(item.notification.title)}</h5>

      <Collapse in={expanded} className={styles.desc}>
        {String(item.notification.message)}
      </Collapse>

      <span className={styles.extendButton} onClick={handleToggleExpand}>
        {expanded ? 'Скрыть детали' : 'Показать больше'}
      </span>
    </>
  );
};

export default NotificationItemsContent;
